module.exports = __webpack_public_path__ + "static/media/video_consent_audio_bhojpuri.6784ac25.mp3";